"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }
  return to;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var reconnect_js_1 = require("reconnect.js");
var ArrowToRight_1 = require("@styled-icons/boxicons-regular/ArrowToRight");
var ArrowToLeft_1 = require("@styled-icons/boxicons-regular/ArrowToLeft");
var Trash_1 = require("@styled-icons/boxicons-regular/Trash");
var CloudDownload_1 = require("@styled-icons/boxicons-regular/CloudDownload");
var styled_components_1 = __importDefault(require("styled-components"));
var antd_1 = require("antd");
var StorageActions = __importStar(require("../../Actions/Storage"));
var core_1 = require("@rjsf/core");
// @ts-ignore
var antd_2 = require("@rjsf/antd");
var RjsForm = core_1.withTheme(antd_2.Theme);
var FileUploader = function FileUploader(props) {
  var actions = reconnect_js_1.useOutlet('actions')[0];
  var onFinished = props.onFinished,
    files = props.files,
    maxLength = props.maxLength,
    name = props.name;
  var _a = react_1.useState(false),
    dragging = _a[0],
    setDragging = _a[1];
  var onFileSelect = function onFileSelect(e) {
    return __awaiter(void 0, void 0, void 0, function () {
      var file, url;
      return __generator(this, function (_a) {
        try {
          if (maxLength) {
            if (files.length + 1 > maxLength) {
              antd_1.message.error('超過上傳限制');
              return [2 /*return*/];
            }
          }

          actions.setLoading(true);
          file = e.target.files[0];
          if (onFinished) {
            url = URL.createObjectURL(file);
            onFinished({
              file_name: file.name,
              file_size: file.size,
              key: '',
              expected_url: url,
              file_type: file.type,
              fileObj: file,
              extra_data: {}
            });
          }
        } catch (e) {
          console.warn(e);
        } finally {
          actions.setLoading(false);
        }
        return [2 /*return*/];
      });
    });
  };

  var onFilesDrop = function onFilesDrop(e) {
    return __awaiter(void 0, void 0, void 0, function () {
      var tempFileList, nextFileList, i, file, _i, tempFileList_1, file, url;
      return __generator(this, function (_a) {
        e.preventDefault();
        try {
          tempFileList = [];
          nextFileList = [];
          if (e.dataTransfer.items) {
            for (i = 0; i < e.dataTransfer.items.length; i++) {
              if (e.dataTransfer.items[i].kind === 'file') {
                file = e.dataTransfer.items[i].getAsFile();
                tempFileList.push(file);
              }
            }
          }
          if (maxLength) {
            if (files.length + tempFileList.length > maxLength) {
              antd_1.message.error('超過上傳限制');
              return [2 /*return*/];
            }
          }

          for (_i = 0, tempFileList_1 = tempFileList; _i < tempFileList_1.length; _i++) {
            file = tempFileList_1[_i];
            url = URL.createObjectURL(file);
            nextFileList.push({
              file_name: file.name,
              file_size: file.size,
              key: '',
              expected_url: url,
              file_type: file.type,
              fileObj: file,
              extra_data: {}
            });
          }
          if (onFinished) {
            onFinished(nextFileList);
          }
        } catch (e) {
          console.warn(e);
        } finally {
          actions.setLoading(false);
          setDragging(false);
        }
        return [2 /*return*/];
      });
    });
  };

  return react_1.default.createElement(StyledUploader, {
    dragging: dragging
  }, react_1.default.createElement("input", {
    id: "rev-files-uploader-" + name,
    type: "file",
    onChange: onFileSelect
  }), react_1.default.createElement("label", {
    onDragEnter: function onDragEnter(e) {
      e.preventDefault();
      setDragging(true);
    },
    onDragLeave: function onDragLeave() {
      setDragging(false);
    },
    onDragOver: function onDragOver(e) {
      e.preventDefault();
    },
    onDrop: onFilesDrop,
    htmlFor: "rev-files-uploader-" + name
  }, "\u9078\u64C7\u6216\u62D6\u66F3\u6A94\u6848\u81F3\u6B64"));
};
var StyledUploader = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  input {\n    display: none;\n    opacity: 0;\n  }\n  label {\n    display: inline-block;\n    font-size: 14px;\n    border: 1px dashed #ccc;\n    border-radius: 3px;\n    padding: 10px 15px;\n    transition: all 400ms ease;\n    cursor: pointer;\n    :hover {\n      color: #40a9ff;\n      border-color: #40a9ff;\n    }\n    ", "\n  }\n"], ["\n  input {\n    display: none;\n    opacity: 0;\n  }\n  label {\n    display: inline-block;\n    font-size: 14px;\n    border: 1px dashed #ccc;\n    border-radius: 3px;\n    padding: 10px 15px;\n    transition: all 400ms ease;\n    cursor: pointer;\n    :hover {\n      color: #40a9ff;\n      border-color: #40a9ff;\n    }\n    ", "\n  }\n"])), function (_a) {
  var dragging = _a.dragging;
  return dragging ? "\n   border: 3px dashed #000; \n   color: #40a9ff;\n   border-color: #40a9ff;\n    " : "";
});
var ChangeFileExtraDataContent = function ChangeFileExtraDataContent(props) {
  var file = props.file,
    setFile = props.setFile,
    schema = props.schema,
    modal = props.modal;
  var _a = react_1.useState(file),
    _file = _a[0],
    _setFile = _a[1];
  react_1.useEffect(function () {
    modal.update({
      onOk: function onOk() {
        setFile(__assign({}, _file));
      }
    });
  }, [_file, modal, setFile]);
  return react_1.default.createElement("div", null, react_1.default.createElement(RjsForm, {
    schema: schema,
    formData: _file.extra_data,
    onChange: function onChange(_a) {
      var formData = _a.formData;
      _setFile(__assign(__assign({}, file), {
        extra_data: __assign({}, formData)
      }));
    }
  }, react_1.default.createElement("div", null)));
};
var FileItem = function FileItem(props) {
  var _a;
  var onDelete = props.onDelete,
    onMoveLeft = props.onMoveLeft,
    onMoveRight = props.onMoveRight,
    removable = props.removable,
    idx = props.idx,
    file = props.file,
    setFile = props.setFile,
    schema = props.schema;
  var onDownload = function onDownload() {
    return __awaiter(void 0, void 0, void 0, function () {
      var _file, fileBlob, fileUrl, link, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 3, 4, 5]);
            return [4 /*yield*/, fetch(file.expected_url)];
          case 1:
            _file = _a.sent();
            return [4 /*yield*/, _file.blob()];
          case 2:
            fileBlob = _a.sent();
            fileUrl = URL.createObjectURL(fileBlob);
            link = document.createElement('a');
            link.href = fileUrl;
            link.download = 'file';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            return [3 /*break*/, 5];
          case 3:
            e_1 = _a.sent();
            console.log('debug', e_1);
            antd_1.message.error('下載失敗，請稍後重新嘗試。');
            return [3 /*break*/, 5];
          case 4:
            antd_1.message.success('下載成功，下載進行中。');
            return [7 /*endfinally*/];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  };

  return react_1.default.createElement(antd_1.Card, {
    style: {
      marginRight: 15
    },
    bodyStyle: {
      height: 'calc(100% - 57px)',
      display: 'flex',
      flexDirection: 'column'
    },
    actions: removable ? [react_1.default.createElement(ArrowToLeft_1.ArrowToLeft, {
      size: 32,
      color: "#6b6b6b",
      onClick: onMoveLeft
    }), react_1.default.createElement(ArrowToRight_1.ArrowToRight, {
      size: 32,
      color: "#6b6b6b",
      onClick: onMoveRight
    }), react_1.default.createElement(Trash_1.Trash, {
      size: 32,
      color: "#d40e00",
      onClick: onDelete
    }), react_1.default.createElement(CloudDownload_1.CloudDownload, {
      size: 32,
      color: "#6b6b6b",
      onClick: onDownload
    })] : [react_1.default.createElement(ArrowToLeft_1.ArrowToLeft, {
      size: 32,
      color: "#6b6b6b",
      onClick: onMoveLeft
    }), react_1.default.createElement(ArrowToRight_1.ArrowToRight, {
      size: 32,
      color: "#6b6b6b",
      onClick: onMoveRight
    }), react_1.default.createElement(CloudDownload_1.CloudDownload, {
      size: 32,
      color: "#6b6b6b",
      onClick: onDownload
    })]
  }, react_1.default.createElement("h2", {
    style: {
      width: 30,
      height: 30,
      fontStyle: 'italic'
    }
  }, idx + 1 + "."), ' ', react_1.default.createElement(antd_1.Image, {
    fallback: "https://revtel-puzzlego-stg.s3.ap-northeast-1.amazonaws.com/files-1637051068",
    src: file.expected_url,
    style: {
      objectFit: 'contain',
      width: 200,
      height: 200,
      backgroundColor: '#fff',
      padding: 10
    },
    alt: "file-url"
  }), (((_a = Object.keys((schema === null || schema === void 0 ? void 0 : schema.properties) || {})) === null || _a === void 0 ? void 0 : _a.length) || 0) > 0 && react_1.default.createElement(antd_1.Button, {
    onClick: function onClick() {
      var info = antd_1.Modal.info({});
      info.update({
        icon: null,
        visible: true,
        maskClosable: true,
        okText: '更新',
        content: react_1.default.createElement(ChangeFileExtraDataContent, {
          modal: info,
          schema: schema,
          file: file,
          setFile: setFile
        })
      });
    }
  }, "\u7DE8\u8F2F\u8CC7\u6599"));
};
var RevFilesUploader = function RevFilesUploader(props) {
  var formData = props.formData,
    schema = props.schema,
    onChange = props.onChange,
    refer = props.refer,
    token = props.token,
    name = props.name;
  var files = formData || [];
  var removable = schema.removable !== false;
  refer.onUpload = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var readyToUploadFiles, originalFiles, list, _i, readyToUploadFiles_1, file, presign, resp, formData_1, key;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            readyToUploadFiles = files.map(function (f, index) {
              return __assign(__assign({}, f), {
                index: index
              });
            }).filter(function (f, index) {
              return f.expected_url.indexOf('blob:') === 0;
            });
            originalFiles = files.map(function (f, index) {
              return __assign(__assign({}, f), {
                index: index
              });
            }).filter(function (f) {
              return !(f.expected_url.indexOf('blob:') === 0);
            });
            list = [];
            _i = 0, readyToUploadFiles_1 = readyToUploadFiles;
            _a.label = 1;
          case 1:
            if (!(_i < readyToUploadFiles_1.length)) return [3 /*break*/, 5];
            file = readyToUploadFiles_1[_i];
            presign = {
              file: file.fileObj,
              options: {
                acl: 'public-read',
                token: token
              }
            };
            return [4 /*yield*/, StorageActions.getUploadUrlFromFile(presign.file, presign.options)];
          case 2:
            resp = _a.sent();
            formData_1 = new FormData();
            for (key in resp.fields) {
              formData_1.append(key, resp.fields[key]);
            }
            formData_1.append('file', file.fileObj);
            return [4 /*yield*/, StorageActions.uploadFile(resp.url, formData_1)];
          case 3:
            _a.sent();
            list.push({
              file_name: file.file_name,
              file_size: file.file_size,
              file_type: file.file_type,
              index: file.index,
              key: resp.fields.key,
              expected_url: resp.expected
            });
            _a.label = 4;
          case 4:
            _i++;
            return [3 /*break*/, 1];
          case 5:
            return [2 /*return*/, __spreadArray(__spreadArray([], originalFiles), list).sort(function (prev, next) {
              return prev.index - next.index;
            }).map(function (_a) {
              var index = _a.index,
                f = __rest(_a, ["index"]);
              return f;
            })];
        }
      });
    });
  };
  var setFiles = function setFiles(nextFiles) {
    onChange(__spreadArray([], nextFiles));
  };
  var onFinished = function onFinished(_files) {
    var nextFiles = Array.isArray(_files) ? __spreadArray(__spreadArray([], files), _files) : __spreadArray(__spreadArray([], files), [_files]);
    setFiles(__spreadArray([], nextFiles));
  };
  var moveElement = function moveElement(arr, old_idx, new_idx) {
    arr = __spreadArray([], arr);
    arr.splice(new_idx, 0, arr.splice(old_idx, 1)[0]);
    setFiles(arr);
  };
  var deleteElement = function deleteElement(arr, idx) {
    arr = __spreadArray([], arr);
    arr.splice(idx, 1);
    setFiles(arr);
  };
  return react_1.default.createElement("div", {
    style: {
      margin: '10px 0',
      maxWidth: 800
    }
  }, react_1.default.createElement("p", {
    style: {
      marginBottom: 10
    }
  }, schema.title, "\u6A94\u6848"), react_1.default.createElement(FileUploader, {
    name: name,
    files: files,
    onFinished: onFinished,
    maxLength: schema.maxLength
  }), react_1.default.createElement("div", {
    style: {
      width: '100%',
      overflowX: 'auto'
    }
  }, react_1.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: 10
    }
  }, Array.isArray(files) && files.map(function (file, idx) {
    return react_1.default.createElement(FileItem, {
      idx: idx,
      key: idx,
      file: file,
      setFile: function setFile(file) {
        var nextFiles = __spreadArray([], files);
        nextFiles[idx] = __assign({}, file);
        setFiles(__spreadArray([], nextFiles));
      },
      removable: removable,
      onMoveLeft: function onMoveLeft() {
        return moveElement(files, idx, idx - 1);
      },
      onMoveRight: function onMoveRight() {
        return moveElement(files, idx, idx + 1);
      },
      onDelete: function onDelete() {
        return deleteElement(files, idx);
      },
      schema: schema.items
    });
  }))));
};
exports.default = RevFilesUploader;
var templateObject_1;